module.exports = __webpack_public_path__ + "img/open-data-success.b282f045.gif";